<script lang="ts">
    import Popup from './Popup.svelte'
    import { glossary as gl } from '../Glossary'
    import type { Glossary } from '../types/Glossar'
    import type { Readable } from 'svelte/store'

    const glossary = gl as Readable<Glossary>

    export let glossaryId: string
    export let innerText: string

    let showPopup = false

    function onKeyDown(e: KeyboardEvent) {
        if (e.key === ' ' || e.key === 'Enter') {
            showPopup = !showPopup
            e.preventDefault()
            e.stopPropagation()
        }
    }

    function onFocus() {
        window.addEventListener('keydown', onKeyDown)
    }

    function onBlur() {
        showPopup = false
        window.removeEventListener('keydown', onKeyDown)
    }
</script>

<span class:exists={glossaryId in $glossary}>
    <span tabindex="0" on:focus={onFocus} on:blur={onBlur} on:click={() => (showPopup = !showPopup)}
        >{innerText}</span
    >
    {#if showPopup && glossaryId in $glossary}
        <Popup on:dismiss={() => (showPopup = false)}>
            <h4>{$glossary[glossaryId].title}</h4>
            {@html $glossary[glossaryId].text}
        </Popup>
    {/if}
</span>

<style lang="scss">
    span {
        position: relative;
    }
    .exists > span {
        cursor: help;
        border-bottom: dotted 2px var(--color-primary);
    }
    h4 {
        margin: 0;
    }
</style>
